export * from "./tailwindHexColors.js";
export * from "./groupBy.js";
export * from "./timeRangeToString.js";
export * from "./cn.js";
export * from "./decodeFA.js";
export * from "./shortenUrl.js";
export * from "./imageCompression.js";
export * from "./gummyChip.js";

export const getFileExtension = (name?: string | null): string => {
  if (!name) return "";
  const parts = name.split(".");
  return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
};

export const isImageFile = (name?: string | null): boolean => {
  const ext = getFileExtension(name);
  return ["jpg", "jpeg", "png", "gif", "webp", "svg", "avif"].includes(ext);
};

export const downloadBlob = async (url: string, filename: string) => {
  const res = await fetch(url);
  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(objectUrl);
};
